export default __webpack_public_path__ + "images/912ba3ec784cac6bcbbddd864eed1b35.png";